import { render, staticRenderFns } from "./d-header.vue?vue&type=template&id=83c90c74&scoped=true&"
import script from "./d-header.vue?vue&type=script&lang=js&"
export * from "./d-header.vue?vue&type=script&lang=js&"
import style0 from "./d-header.vue?vue&type=style&index=0&id=83c90c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c90c74",
  null
  
)

export default component.exports